import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const a = "feedback/feedback_looker_studio";
class r extends s {
  async getFeedbackLookerStudio(e) {
    const { data: t } = await this.get(`${a}/${e}`);
    return t;
  }
  async updateFeedbackLookerStudio(e, t) {
    const { data: o } = await this.put(
      `${a}/${e}`,
      t
    );
    return o;
  }
  async createFeedbackLookerStudio(e) {
    const { data: t } = await this.post(a, e);
    return t;
  }
}
export {
  r as FeedbackLookerStudio
};
